<template>
  <div class="slider fl">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item, index) in imgData" :key="index">
        <a @click="handleOp(item)"
          ><img class="slider-img" :src="item.imgUrl"
        /></a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
// import { updateHits } from "@/app/procurementNotice/api/shopping";
import { updateAdvHits } from "../api/shopping";
export default {
  name: "slideShow",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        //循环
        // loop: true,
        // //设定初始化时slide的索引
        // initialSlide: 0,
        //自动播放
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false, //loop模式下无效
          disableOnInteraction: false
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        //滑动速度
        speed: 300,
        // //滑动方向
        // direction: "horizontal",
        //小手掌抓取滑动
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}" onmouseover="this.click()"></span>`;
          }
        }
      }
    };
  },
  mounted() {},
  methods: {
    handleOp(item) {
      //点击量
      // updateHits({
      //   publicityContentId: item.publicityContentId
      // });
      if (item.linkUrl) {
        updateAdvHits({
          advInfoId: item.id
        });
        window.open(item.linkUrl, "_blank");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.slider {
  width: 930px;
  height: 370px;
  background: #ffffff;
  margin: 0 10px;
  .slider-img {
    width: 100%;
    height: 400px;
  }
}
/deep/ .swiper-pagination {
  display: flex;
  justify-content: flex-end;
  transform: translate(-25px, -10px);
}
/deep/ .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
}
/deep/ .swiper-pagination-bullet-active {
  background-color: #ffffff;
}
.fl {
  float: left;
}
.swiper-wrapper {
  transition-timing-function: linear !important;
}
</style>
